const TourNavLabel = {
  DOWNLOAD: "clientPanelMisc:downloadCenter",
  INFO: "clientPanelMisc:info",
  ADDRESS: "clientPanelMisc:address",
  MLS: "clientPanelMisc:mls",
  SETTINGS: "clientPanelMisc:settings",
  IMMERSIVE_3D_TOUR: "immersive3dTour",
  UI_MEET_3D: "uiMeet3d",
  MEDIA_EDIT: "clientPanelMisc:mediaEdit",
  MEDIA_SETTINGS: "clientPanelMisc:mediaSettings",
  VIDEO: "clientPanelMisc:videoRequest",
  FLYER: "clientPanelMisc:flyerEdit",
  STATS: "clientPanelMisc:stats",
  LINKS: "clientPanelMisc:links",
};

export default TourNavLabel;
